import { useState, useCallback } from 'react';
import { apiFetch } from '../../../auth/apiFetch';

const apiBaseUrl = process.env.REACT_APP_API_URL || window.location.origin;

function useProductLookup() {
  const [results, setResults] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const lookupKeys = useCallback(async (keysInput) => {
    setIsLoading(true);
    setError(null);
    setResults(null);

    try {
      // Parse input: split by comma or newline, trim whitespace, filter empty
      const keys = keysInput
        .split(/[,\n]/)
        .map(k => k.trim())
        .filter(k => k.length > 0);

      if (keys.length === 0) {
        throw new Error('Please enter at least one key');
      }

      const response = await apiFetch(`${apiBaseUrl}/api/document/digital-asset-keys`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ keys }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
        throw new Error(errorData.detail || `HTTP ${response.status}`);
      }

      const data = await response.json();
      setResults(data);
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearResults = useCallback(() => {
    setResults(null);
    setError(null);
  }, []);

  return {
    results,
    isLoading,
    error,
    lookupKeys,
    clearResults,
  };
}

export default useProductLookup;
